import { IButtonWithBadge } from "@mctypes/frontend.types";
import { IMinProject } from "@mctypes/global.types";
import { IIssueBoardApi } from "@mcapps/shared";
import { IIssueApi } from "@schemas/issueSchema";
import React from "react";
import { useGetFilesFromAzureBlobStorageQuery } from "../../../../../azureBlobStorageRTK";
import { IssueTabsEnum } from "../../../issueConstants";
import { getIssueActionNameOption, getTaskCompleteCount } from "../../../issueUtils";
import ButtonGroupWithBadge from "./ButtonGroupWithBadge";

type IssueItemButtonGroupsProps = {
  issue: IIssueApi;
  activeButtonName: IssueTabsEnum;
  setSelectedButtonName: (name: IssueTabsEnum) => void;
  taskOrIssue: "ISSUE" | "TASK" | string;
  projectIsGisActivated: boolean;
  issueBoard: IIssueBoardApi;
};

export const IssueItemButtonGroups: React.FC<IssueItemButtonGroupsProps> = ({
  issue,
  activeButtonName,
  setSelectedButtonName,
  taskOrIssue,
  issueBoard,
}) => {
  const project = issue?.project as IMinProject | string;
  const projectId = typeof project === "string" ? project : project?._id;
  const path = projectId ? `${projectId}/issue/${issue?._id}/files` : undefined;

  const { data: files } = useGetFilesFromAzureBlobStorageQuery(
    { projectId, path },
    { skip: projectId == null || path == null },
  );

  const buttons: IButtonWithBadge[] = [
    { name: IssueTabsEnum.INFO, value: IssueTabsEnum.INFO },
    ...(taskOrIssue === "ISSUE"
      ? [
          {
            name: getIssueActionNameOption(issueBoard?.taskNameSetting, "plural"),
            value: IssueTabsEnum.ACTIONS,
            taskCompleteCount: getTaskCompleteCount(issue),
          } as IButtonWithBadge,
        ]
      : []),
    {
      name: IssueTabsEnum.FILES,
      value: IssueTabsEnum.FILES,
      badgeCount: files?.length ?? 0,
    },
    {
      name: IssueTabsEnum.LOG,
      value: IssueTabsEnum.LOG,
    },
  ];

  return (
    <ButtonGroupWithBadge
      buttons={buttons}
      activeButtonName={activeButtonName}
      setSelectedButtonName={setSelectedButtonName}
    />
  );
};
